import request from '@/utils/request'

export function getGasOrderDetail(uid) {
    return request({
        url: '/wx/gas-order-h5/' + uid,
        method: 'get'
    })
}
export function getNaturalPipeItem(params) {
    return request({
        url: '/wxagent/naturalPipe-items',
        method: 'get',
        params
    })
}

export function getSecurityIndoor(uaid) {
    return request({
        url: '/wx/last-security/' + uaid,
        method: 'get'
    })
}

//液化气安检项
export function getSecurityItem(params) {
    return request({
        url: '/wx/security-items',
        method: 'get',
        params
    })
}
// 天然气安检项
export function getNaturalItem() {
    return request({
        url: '/wx/naturalgas-items',
        method: 'get'
    })
}

// 天然气获取配置项
export function getNaturalgasConfig(data) {
    return request({
        url: '/wx/naturalgas-config',
        method: 'get',
    })
}